module.exports = __webpack_public_path__ + "img/exam_g_bj.9f8d2b90.png";